// extracted by css-extract-rspack-plugin
export default {"box":"E3LNRcV4HT0mAMKs"};